// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rGwyUXveypw_X_C1c6z3{color:var(--content-primary-tertiary)}.gP1evuyC_asx9duqviIE{grid-template-columns:auto max-content;margin-left:8px;display:grid}.VbNHc8DUN5BV6JNvcQIH{align-items:center;display:flex}.UR4RM2T0XMAivPxCEhPZ{color:var(--content-primary-tertiary);padding:0 8px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon": `rGwyUXveypw_X_C1c6z3`,
	"info": `gP1evuyC_asx9duqviIE`,
	"number": `VbNHc8DUN5BV6JNvcQIH`,
	"number__point": `UR4RM2T0XMAivPxCEhPZ`,
	"numberPoint": `UR4RM2T0XMAivPxCEhPZ`
};
export default ___CSS_LOADER_EXPORT___;
